import { useStaticQuery, graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import Section from '../common/Section';
import Club from '../icons/club.svg';
import Crm from '../icons/crm.svg';
import Ecommerce from '../icons/ecommerce.svg';
import PointOfSale from '../icons/pos.svg';
import Reservations from '../icons/reservations.svg';

const CustomerExperience = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "home/consumer.png" }) {
        ...displayImageFragment
      }
    }
  `);

  return (
    <StyledSection>
      <Title>
        Customer experience is the #1 reason why a consumer chooses a brand
      </Title>
      <Subtitle>
        We make it easy to provide your customers with the best shopping
        experience possible, regardless of channel.
      </Subtitle>
      <ContentWrapper>
        <ImageWrapper>
          <GatsbyImage
            image={data.image.childImageSharp.gatsbyImageData}
            alt="A screenshot of Commerce7 platform."
          />
        </ImageWrapper>
        <Solutions>
          <SolutionLink to="/solutions/pos">
            <SolutionIcon>
              <PointOfSale />
            </SolutionIcon>
            <SolutionLabel>Point of Sale</SolutionLabel>
          </SolutionLink>
          <SolutionLink to="/solutions/club">
            <SolutionIcon>
              <Club />
            </SolutionIcon>
            <SolutionLabel>Clubs &amp; Subscriptions</SolutionLabel>
          </SolutionLink>
          <SolutionLink to="/solutions/ecommerce">
            <SolutionIcon>
              <Ecommerce />
            </SolutionIcon>
            <SolutionLabel>Ecommerce</SolutionLabel>
          </SolutionLink>
          <SolutionLink to="/solutions/crm">
            <SolutionIcon>
              <Crm />
            </SolutionIcon>
            <SolutionLabel>CRM</SolutionLabel>
          </SolutionLink>
          <SolutionLink to="/solutions/reservations">
            <SolutionIcon>
              <Reservations />
            </SolutionIcon>
            <SolutionLabel>Reservations</SolutionLabel>
          </SolutionLink>
        </Solutions>
      </ContentWrapper>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  padding-top: 125px;
  margin-bottom: 250px;
`;

const Title = styled.h2`
  text-align: center;
  color: var(--blue-dark);
  line-height: var(--line-height-base);
  font-size: var(--heading-size-base);
  font-weight: var(--font-weight-black);
  max-width: 915px;
  margin: 0 auto 15px;
  ${({ theme }) => `
  @media ${theme.mediumUp} {
    line-height: var(--line-height-sm);
    font-size: var(--heading-size-xl);
  }
`}
`;

const Subtitle = styled.p`
  font-size: var(--font-size-lg);
  text-align: center;
  max-width: 850px;
  margin: 0 auto 90px;
`;

const ContentWrapper = styled.div`
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      display: flex;
      align-items: start;
    }
  `}
`;

const ImageWrapper = styled.div`
  margin-bottom: 30px;

  ${({ theme }) => `
    @media ${theme.mediumUp} {
      width: 66%;
      max-width: none;
      padding-right: 100px;
      margin-bottom: 0;
    }
  `}
`;

const Solutions = styled.div`
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      width: 33%;
      padding-top: 50px;
    }
  `}
`;

const SolutionLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const SolutionIcon = styled.div`
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  border: 1px solid #dcdfe8;
  border-radius: 50%;
  box-shadow: 1px 2px 8px rgba(7, 32, 128, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
  svg {
    width: 24px;
    height: 24px;
  }
`;

const SolutionLabel = styled.h3`
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  ${({ theme }) => `
    @media ${theme.xLargeUp} {
     font-size: 24px;
    }
  `}
`;

export default CustomerExperience;
